module.exports = __webpack_public_path__ + "img/chargingstation-inprogress.fa748cb4.svg";